import { useNavigate, useSearch } from '@tanstack/react-router';

const useSort = () => {
    const navigate = useNavigate();
    const { ordering } = useSearch({});
    const parsedOrdering = ordering?.split(',');

    const getSort = (field: string) => {
        if (parsedOrdering?.includes(field)) return 'asc';
        if (parsedOrdering?.includes('-'.concat(field))) return 'desc';
    };

    const setSort = (field: string, direction?: SortDirection) => {
        const newSort =
            parsedOrdering?.filter(
                item => ![field, '-'.concat(field)].includes(item),
            ) || [];
        if (direction)
            newSort.unshift(direction === 'asc' ? field : '-'.concat(field));
        if (!newSort.length)
            navigate({ search: ({ ordering, ...prev }) => prev });
        else
            navigate({
                search: prev => ({ ...prev, ordering: newSort.join(',') }),
            });
    };

    return { getSort, setSort };
};

export default useSort;
